// Defence in depth for card source links: only http(s) URLs become an href.
// Anything else (javascript:, data:, unparseable) falls back to '#', the same
// placeholder parseDataverseItem uses when a row has no source URL. Shared by
// UpdateCard and CommunityCard.
export function safeHref(url: string): string {
  try {
    const { protocol } = new URL(url);
    return protocol === 'https:' || protocol === 'http:' ? url : '#';
  } catch {
    return '#';
  }
}
